const route = {
	name: 'job-evaluation',
	path: 'job-evaluation',
	component: () => import('@/modules/job-evaluation/pages/page-job-evaluation'),
	meta: {
		title: 'Valoración de Puestos',
	},
	props: true,
	redirect: '/job-evaluation/onboarding',
	children: [
		{
			name: 'job-evaluation-onboarding',
			path: 'onboarding',
			component: () => import('@/modules/job-evaluation/pages/page-job-evaluation-onboarding'),
		},
		{
			name: 'job-evaluation-new',
			path: 'new',
			component: () => import('@/modules/job-evaluation/pages/page-job-evaluation-new'),
			children: [
				{
					name: 'job-evaluation-supplies',
					path: 'supplies',
					component: () => import('@/modules/job-evaluation/pages/supplies/page-job-evaluation-supplies'),
					meta: {
						title: 'Insumos',
					},
					children: [
						{
							name: 'job-supply-guideline-model',
							path: 'guideline-model',
							component: () => import('@/modules/job-evaluation/pages/supplies/guideline-model/page-supply-guideline-model'),
							meta: {
								title: 'Modelo Directriz',
							},
						},
						{
							name: 'job-supply-guideline-model-hierarchy',
							path: 'guideline-model-hierarchy',
							component: () => import('@/modules/job-evaluation/pages/supplies/guideline-model/page-supply-guideline-model-hierarchy'),
							meta: {
								title: 'Modelo Directriz',
							},
						},
						{
							name: 'job-supply-organization-chart',
							path: 'organization-chart',
							component: () => import('@/modules/job-evaluation/pages/supplies/organization-chart/page-supply-organization-chart'),
							meta: {
								title: 'Organigrama',
							},
						},
						{
							name: 'job-supply-valuation-model',
							path: 'valuation-model',
							component: () => import('@/modules/job-evaluation/pages/supplies/valuation-model/ValuationModelPage'),
							meta: {
								title: 'Modelo de Valoración',
							},
							redirect: '/job-evaluation/new/supplies/valuation-model/factors-choice',
							children: [
								{
									name: 'job-supply-valuation-model-factors-choice',
									path: 'factors-choice',
									component: () => import('@/modules/job-evaluation/pages/supplies/valuation-model/step-pages/FactorsChoicePage'),
									meta: {
										title: 'Nuevo',
									},
								},
								{
									name: 'job-supply-valuation-model-factors-weighting',
									path: 'factors-weighting',
									component: () => import('@/modules/job-evaluation/pages/supplies/valuation-model/step-pages/FactorsWeightingPage'),
									meta: {
										title: 'Nuevo',
									},
								},
								{
									name: 'job-supply-valuation-model-degrees',
									path: 'degrees',
									component: () => import('@/modules/job-evaluation/pages/supplies/valuation-model/step-pages/DegreesPage'),
									meta: {
										title: 'Nuevo',
									},
								},
								{
									name: 'job-supply-valuation-model-payroll-proposal',
									path: 'payroll-proposal',
									component: () => import('@/modules/job-evaluation/pages/supplies/valuation-model/step-pages/PayrollProposalPage'),
									meta: {
										title: 'Nuevo',
									},
								},
							],
						},
					],
				},
				{
					name: 'job-evaluation-processes',
					path: 'processes',
					component: () => import('@/modules/job-evaluation/pages/supplies/page-job-evaluation-processes'),
					meta: {
						title: 'Procesos',
					},
					children: [
						{
							name: 'job-evaluation-processes-commitees',
							path: 'organize-committee',
							component: () => import('@/modules/job-evaluation/pages/commitees/page-commitees-list'),
							meta: {
								title: 'Comités',
							},
							children: [
								{
									name: 'new-commitees',
									path: 'new/:name?/:id?',
									components: {
										newCommiteeForm: () => import('@/modules/job-evaluation/pages/commitees/new-form-commitees'),
									},
									meta: {
										title: 'Nuevo Comité',
									},
								},
							],
						},
					],
				},
			],
		},
	],
};
export default route;



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/router/index.js